import { defineEntity, custom } from './_helpers.js';

export default defineEntity('problem', {
    candidateRaised: custom({ scope: 'state' }),
    candidateAccepted: custom({ scope: 'state' }),
    candidateDismissed: custom({ scope: 'state' }),
});
